import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import enLocale from './en'
import zhLocale from './zh'
// 引入mixin逻辑
import './mixin'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

export const LANGUAGE_STORAGE_KEY = 'language-seller'

export function normalizeLanguage(language) {
  return language === 'zh' ? 'zh' : 'en'
}

const i18n = new VueI18n({
  locale: normalizeLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY)),
  messages
})

export function applyLanguage(language) {
  const previousLanguage = i18n.locale
  const latestLanguage = normalizeLanguage(language)
  if (i18n.locale !== latestLanguage) {
    i18n.locale = latestLanguage
  }

  return {
    changed: previousLanguage !== latestLanguage,
    previousLanguage,
    language: latestLanguage
  }
}

export function applyLatestLanguage() {
  return applyLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY))
}

// 对接element-ui locale
locale.i18n((key, value) => i18n.t(key, value))

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js